import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

const Section = ({ n, title, children }) => (
  <div className="grid grid-cols-1 md:grid-cols-12 gap-8 py-10 border-b border-[#0A192F]/10">
    <div className="md:col-span-3">
      <div className="font-mono text-xs text-[#F59E0B] mb-2">{n}</div>
      <h2 className="font-serif text-2xl text-[#0A192F]">{title}</h2>
    </div>
    <div className="md:col-span-9 text-[#4A5568] text-sm leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-[#F9F9F8]">
      <header className="border-b border-[#0A192F]/10 bg-white/80 backdrop-blur-xl">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/"><Logo /></Link>
          <nav className="flex gap-6 text-sm">
            <Link to="/security" className="text-[#4A5568]">Security</Link>
            <Link to="/privacy" className="text-[#0A192F] font-medium">Privacy</Link>
            <Link to="/terms" className="text-[#4A5568]">Terms</Link>
          </nav>
        </div>
      </header>
      <section className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="font-overline text-[#4A5568] mb-4">Privacy notice</div>
        <h1 className="font-serif text-5xl sm:text-6xl tracking-tight text-[#0A192F]">Your data, your call.</h1>
        <p className="mt-6 text-[#4A5568] max-w-2xl">
          This notice explains what NTN collects, how it's used, and the controls you have. It applies to property
          manager clients, NTN staff, and applicants whose data passes through our platform.
        </p>
      </section>
      <section className="max-w-7xl mx-auto px-6 lg:px-8 pb-24">
        <Section n="01" title="What we collect">
          <p>For property managers: name, email, company, IP, audit log of platform actions.</p>
          <p>For applicants: name, contact info, property address, financial documents you submit (paystubs, ID, etc.), and the resulting screening reports.</p>
        </Section>
        <Section n="02" title="How we use it">
          <p>To deliver the screening reports you request, to communicate within an application thread, to enforce platform security (lockout/audit), and to comply with the Fair Credit Reporting Act (FCRA).</p>
          <p>We do <strong>not</strong> sell your data. We do not share applicant data with parties other than the requesting property manager and the underlying report providers (e.g., credit bureau).</p>
        </Section>
        <Section n="03" title="How long we keep it">
          <p>Active screening records: kept for 7 years (FCRA standard) unless you request deletion.</p>
          <p>Audit logs: 7 years, append-only.</p>
          <p>Soft-deleted accounts: hard-deleted 30 days after request unless reinstated.</p>
        </Section>
        <Section n="04" title="Your rights">
          <p><strong>Export</strong> — Account → Privacy → Download my data. JSON of every screening, message, file, and audit entry tied to you.</p>
          <p><strong>Delete</strong> — Same panel. Soft-delete is immediate; hard-delete in 30 days.</p>
          <p><strong>Correct</strong> — Email privacy@ntnverify.com to fix any record.</p>
          <p><strong>Opt out of email notifications</strong> — Account → Privacy.</p>
        </Section>
        <Section n="05" title="Cookies">
          <p>We use <em>strictly necessary</em> cookies only: session cookies (access / refresh tokens), security cookies (Cloudflare). No third-party advertising or tracking cookies.</p>
        </Section>
        <Section n="06" title="Contact">
          <p>Questions? privacy@ntnverify.com. Security issues: security@ntnverify.com.</p>
        </Section>
      </section>
      <footer className="border-t border-[#0A192F]/10 py-8 bg-[#F9F9F8]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-xs text-[#4A5568] font-mono">
          © {new Date().getFullYear()} NATIONAL TENANT NETWORK · EFFECTIVE FEB 2026
        </div>
      </footer>
    </div>
  );
}
